import { render, staticRenderFns } from "./TheoryDetails.vue?vue&type=template&id=d6b0c81e"
import script from "./TheoryDetails.vue?vue&type=script&lang=ts"
export * from "./TheoryDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports